/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyWellnessRetreatTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyWellnessRetreat,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Relax and Rejuvenate as a Family!",
    "Family Wellness Retreat Awaits!",
    "Focus on Family Health and Happiness!",
  ],
  title: "Family Wellness Retreat",
  description: "Organize a fun family wellness retreat.",
  longDescription:
    "Gather your family for an exciting wellness retreat! Choose a date, decide on activities, and plan healthy meals!",
  emoji: "🌱",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Wellness Retreat",
          emoji: "🌱",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the family wellness retreat?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description:
              "What activities should we focus on during the retreat?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on meals?",
                  description:
                    "What healthy meals should we plan for the retreat?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🥗",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Focus on Wellness Together!",
    outroDescription:
      "Your family wellness retreat plans are set! Enjoy the tranquility!",
  },
};
